import { defineStore } from 'pinia';
import CaptainLlmCredentialsAPI from 'dashboard/api/captain/llmCredentials';

export const useLlmCredentialStore = defineStore('llmCredentials', {
  state: () => ({
    records: [],
    uiFlags: {
      isFetching: false,
      isSaving: false,
    },
  }),

  getters: {
    getRecords: state => state.records,
    getUIFlags: state => state.uiFlags,
  },

  actions: {
    async fetch() {
      this.uiFlags.isFetching = true;
      try {
        const response = await CaptainLlmCredentialsAPI.get();
        this.records = response.data.payload || [];
      } finally {
        this.uiFlags.isFetching = false;
      }
    },

    async create(data) {
      this.uiFlags.isSaving = true;
      try {
        const response = await CaptainLlmCredentialsAPI.create(data);
        // The API lists the oldest first, and the oldest of a provider is its default.
        this.records = [...this.records, response.data];
        return response.data;
      } finally {
        this.uiFlags.isSaving = false;
      }
    },

    async update(id, data) {
      this.uiFlags.isSaving = true;
      try {
        const response = await CaptainLlmCredentialsAPI.update(id, data);
        this.records = this.records.map(record =>
          record.id === id ? response.data : record
        );
        return response.data;
      } finally {
        this.uiFlags.isSaving = false;
      }
    },

    async delete(id) {
      await CaptainLlmCredentialsAPI.delete(id);
      this.records = this.records.filter(record => record.id !== id);
    },
  },
});
